module.exports = __webpack_public_path__ + "static/img/car-coins.044d992.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/car-coins.webp
// module id = Ls58
// module chunks = 1